import {baseGetRequest} from "../base/baseGetRequest";
import {deviceType} from "./getDevices";

const getDevice = async (id_device: number) =>
  baseGetRequest<deviceType>(`/device/${id_device}/`);

export default getDevice;
